const prices = {
  table: {
    service: "Service",
    priceBgn: "Price (BGN)",
    priceEur: "Price (€)",
    missing: "—",
  },
  hero: {
    title: "Price List",
    description:
      "Current indicative prices in BGN and EUR. For a personalised treatment plan and exact quote, please contact us.",
  },
  section: {
    title: "Prices by service",
    description:
      "If you have any questions or would like to book an appointment, please use the contact form.",
  },
  cards: [
    {
      title: "Crowns",
      rows: [
        { name: "1 pc. MK crown", bgn: "430 BGN", eur: "€219.86" },
        { name: "1 pc. ZR crown", bgn: "800 BGN", eur: "€409.04" },
        {
          name: "1 pc. clinical crown lengthening",
          bgn: "500 BGN",
          eur: "€255.65",
        },
        { name: "1 pc. temporary crown / laboratory", bgn: "40 BGN", eur: "€20.45" },
      ],
    },
    {
      title: "All-on-4",
      sections: [
        {
          title: "Dental composite",
          rows: [
            { name: "1 jaw", bgn: "4,500 BGN", eur: "€2,300.85" },
            { name: "2 jaws", bgn: "9,000 BGN", eur: "€4,601.70" },
          ],
        },
        {
          title: "Metal-ceramic",
          rows: [
            { name: "1 jaw", bgn: "6,000 BGN", eur: "€3,067.80" },
            { name: "2 jaws", bgn: "12,000 BGN", eur: "€6,135.60" },
          ],
        },
      ],
    },
    {
      title: "All-on-6",
      sections: [
        {
          title: "Metal-ceramic",
          rows: [
            { name: "1 jaw", bgn: "8,000 BGN", eur: "€4,090.40" },
            { name: "2 jaws", bgn: "16,000 BGN", eur: "€8,180.80" },
          ],
        },
        {
          title: "Zirconia",
          rows: [
            { name: "1 jaw", bgn: "9,500 BGN", eur: "€4,857.35" },
            { name: "2 jaws", bgn: "19,000 BGN", eur: "€9,714.69" },
          ],
        },
      ],
    },
    {
      title: "Prosthetics",
      rows: [
        { name: "Acrylic denture", bgn: "650 BGN", eur: "€332.34" },
        { name: "Silicone denture", bgn: "900 BGN", eur: "€460.17" },
        { name: "Partial acrylic", bgn: "450 BGN", eur: "€230.08" },
      ],
    },
    {
      title: "Tartar cleaning",
      rows: [{ name: "Scaling and polishing", bgn: "170 BGN", eur: "€86.92" }],
    },
    {
      title: "Filling (obturations)",
      rows: [
        { name: "1 surface", bgn: "120 BGN", eur: "€61.36" },
        { name: "2 surfaces", bgn: "150 BGN", eur: "€76.69" },
        { name: "3 surfaces", bgn: "180 BGN", eur: "€92.03" },
        { name: "after endodontic treatment", note: "depending on surfaces" },
      ],
    },
    {
      title: "Post and core build-up",
      rows: [
        { name: "Metal post", bgn: "150 BGN", eur: "€76.69" },
        { name: "Zirconia post", bgn: "250 BGN", eur: "€127.82" },
      ],
    },
    {
      title: "Extractions",
      rows: [
        { name: "Single-root tooth", bgn: "150 BGN", eur: "€76.69" },
        { name: "Multi-root tooth", bgn: "200 BGN", eur: "€102.26" },
        { name: "Wisdom tooth", bgn: "300 BGN", eur: "€153.39" },
        { name: "Impacted wisdom tooth", bgn: "400 BGN", eur: "€204.52" },
      ],
    },
    {
      title: "Whitening",
      rows: [
        { name: "In-office", bgn: "500 BGN", eur: "€255.65" },
        { name: "At-home", bgn: "400 BGN", eur: "€204.52" },
      ],
    },
    {
      title: "Aesthetic treatments",
      rows: [
        { name: "E-max veneers", bgn: "700 BGN", eur: "€357.91" },
        { name: "Bonding / 1 tooth", bgn: "300 BGN", eur: "€153.39" },
      ],
    },
    {
      title: "X-ray",
      rows: [{ name: "Panoramic x-ray", bgn: "35 BGN", eur: "€17.90" }],
    },
    {
      title: "Bone graft",
      rows: [{ name: "Bone 1 sq.", bgn: "2,000 BGN", eur: "€1,022.60" }],
    },
  ],
};

export default prices;

